module.exports = __webpack_public_path__ + "static/img/xiaodugui7622751.png";